<template>
  <div
    class="size-full overflow-y-auto overflow-x-hidden sm:px-6 lg:px-8"
  >
    <div
      class="flex min-h-full flex-col justify-center py-12"
    >
      <div class="mx-auto max-w-sm">
        <BaseCard>
          <div class="space-y-4">
            <h2 class="text-xl font-semibold">
              Forgot Password
            </h2>
            <p class="text-gray-600">
              Enter your email and we'll send you a link to
              reset your password.
            </p>

            <form class="space-y-6" @submit="onFormSubmit">
              <FormInputText
                name="email"
                type="email"
                autocomplete="email"
                label="Email Address"
              />

              <FormSubmitButton
                :is-loading="isSubmitting"
                class="w-full justify-center text-lg"
              >
                Send Reset Link
              </FormSubmitButton>
            </form>
          </div>
        </BaseCard>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import { z } from "zod"
import { emailAddressSchema } from "@/validation/sharedStringFieldSchemas"

const router = useRouter()

const formSchema = z.object({
  email: emailAddressSchema("Email is required"),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    email: "",
  },
})

const onFormSubmit = handleSubmit(async (values) => {
  try {
    await requestPasswordReset(values.email)
    toast.success("Password reset link sent to your email")
    router.push({ name: "login" })
  } catch {
    toast.error("Failed to send password reset link")
  }
})
</script>
